module.exports = __webpack_public_path__ + "img/groups.d9507c53.svg";